import styled from "styled-components";

export const Purpose = styled.p`
  max-width: 180px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block; /* required if not already block/flex */
`;
